module.exports = __webpack_public_path__ + "971378105cbafe19ffd9c32ae29aff2d.svg";